import { render, staticRenderFns } from "./information-column.vue?vue&type=template&id=5f46fc72"
import script from "./information-column.vue?vue&type=script&lang=js"
export * from "./information-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports